import { SaleUnitCartDto } from "./saleUnitCart.dto";

export interface SaleUnitCartValidationRequestDto {
  saleUnitCart: SaleUnitCartDto;
  saleUnitCartSplitId?: number;
}
